<ds-card class="pi-pregunta-paso-0-card" background="#ffffff" shadow="l2" gap="24px" *ngIf="!errorOps">
  <div class="pi-pregunta-paso-0__header">
    <p class="ds-text-body-s-bold">
      Solicitud de Pensión por Invalidez</p>
    <h2 class="ds-text-h2-l-bold">Antes de iniciar tu solicitud</h2>
    <p class="ds-text-body-regular">
      Necesitamos confirmar si este canal es el adecuado para tu caso</p>
  </div>

  <div class="pi-pregunta-paso-0__panel">
    <p class="ds-text-body-bold">
      ¿Tu invalidez es producto de un accidente o enfermedad laboral?
    </p>
    <div class="pi-pregunta-paso-0__check-row">      
      <ds-radio-group orientation="horizontal" [(value)]="accidenteLaboral" (valueChange)="onAccidenteChange($event)">
        <ds-radio name="radio_accidente" [selected]="false" [disabled]="false" ariaLabel="Si"
          value="si" label="Sí">
        </ds-radio>        
        <ds-radio name="radio_accidente" [selected]="false" [disabled]="false" ariaLabel="No"
          value="no" label="No">
        </ds-radio>
      </ds-radio-group>
    </div>

    <ds-inline-alert type="info" emphasis="outline" size="s"
      description="Al responder sí, el trámite finaliza aquí y podrás continuar en tu mutualidad de seguridad por la Ley 16.744." />
  </div>

  <div class="pi-pregunta-paso-0__panel">
    <p class="ds-text-body-bold">
      ¿Eres empleado público?
    </p>
    <div class="pi-pregunta-paso-0__check-row">
      <ds-radio-group orientation="horizontal" [(value)]="empleadoPublico" (valueChange)="onEmpleadoPublicoChange($event)">
        <ds-radio name="radio_empleado_publico" [selected]="false" [disabled]="false" ariaLabel="Si"
          value="si" label="Sí">
        </ds-radio>
        <ds-radio name="radio_empleado_publico" [selected]="false" [disabled]="false" ariaLabel="No" 
          value="no" label="No">
        </ds-radio>
      </ds-radio-group>
    </div>
  </div>

  <div class="pi-pregunta-paso-0__actions">
    <ds-button-v2 class="pi-pregunta-paso-0__cta" label="Continuar" emphasis="primary" size="m"
      [disabled]="continuarDeshabilitado" (clicked)="continuar()">
    </ds-button-v2>
  </div>
</ds-card>

<app-ds-generic-error *ngIf="errorOps" [ops]="errorOps">
</app-ds-generic-error>